import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { dur, ease } from '../lib/motion';

// Scroll-triggered reveal: dramatic fade + rise/slide + zoom & de-blur. Honors prefers-reduced-motion.
// direction: 'up' (default) | 'left' | 'right'. Explicit x/y override direction.
const Reveal = ({
  children,
  delay = 0,
  y,
  x,
  direction = 'up',
  distance = 96,
  className = '',
  as = 'div',
  once = true,
  amount = 0.15,
}) => {
  const MotionTag = motion[as] || motion.div;
  const reduce = useReducedMotion();

  let iy = y;
  let ix = x;
  if (iy === undefined && ix === undefined) {
    if (direction === 'left') { ix = -distance; iy = 0; }
    else if (direction === 'right') { ix = distance; iy = 0; }
    else { iy = distance; ix = 0; }
  } else {
    iy = iy ?? 0;
    ix = ix ?? 0;
  }

  if (reduce) {
    return (
      <MotionTag
        className={className}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once, amount }}
        transition={{ duration: dur.base, delay: Math.min(delay, 0.1) }}
      >
        {children}
      </MotionTag>
    );
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: iy, x: ix, scale: 0.9, filter: 'blur(10px)' }}
      whileInView={{ opacity: 1, y: 0, x: 0, scale: 1, filter: 'blur(0px)' }}
      viewport={{ once, amount }}
      transition={{ duration: 1.05, delay, ease: ease.entrance }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
